const article = {
    slug: "issey-miyake",
    category: "BRAND BUYBACK",
    listTitle: "ISSEY MIYAKE買取",
    listDescription:
      "PLEATS PLEASE、HOMME PLISSÉ、ISSEY MIYAKE MEN、A-POC、BAO BAO、アーカイブ作品まで、イッセイミヤケの技法と市場価値を見て査定する専用買取ページ。",
    seo: {
      title:
        "ISSEY MIYAKE買取｜イッセイミヤケのアーカイブ価値まで査定するEnclopedia",
      description:
        "ISSEY MIYAKE（イッセイミヤケ）の買取ならEnclopediaへ。PLEATS PLEASE、HOMME PLISSÉ ISSEY MIYAKE、ISSEY MIYAKE MEN、A-POC、BAO BAO、132 5.、アーカイブ作品まで、プリーツ技法・シーズン背景・希少性・市場価値を見て査定。LINE事前査定から全国対応の宅配買取へご案内します。",
      keyword:
        "ISSEY MIYAKE 買取,イッセイミヤケ 買取,ISSEY MIYAKE 高価買取,イッセイミヤケ 高価買取,ISSEY MIYAKE 宅配買取,イッセイミヤケ 宅配買取,ISSEY MIYAKE LINE査定,イッセイミヤケ 買取相場,ISSEY MIYAKE アーカイブ 買取,イッセイミヤケ アーカイブ 買取,PLEATS PLEASE 買取,プリーツプリーズ 買取,HOMME PLISSÉ 買取,オムプリッセ 買取,ISSEY MIYAKE MEN 買取,イッセイミヤケメン 買取,A-POC 買取,BAO BAO 買取,バオバオ 買取,132 5. ISSEY MIYAKE 買取,アーカイブ買取,enclopedia,アンクロペディア",
      canonicalPath: "/brand_buyback/issey-miyake",
    },
    hero: {
      label: "ISSEY MIYAKE BUYBACK",
      number: "09 / BUYBACK",
      titleLines: [
        "ISSEY MIYAKE買取。",
        "技法とアーカイブ価値まで見て査定します。",
      ],
      body:
        "Enclopediaは、ISSEY MIYAKEをブランド名や型番だけで一律に判断しません。\nPLEATS PLEASE、HOMME PLISSÉ、ISSEY MIYAKE MEN、A-POC、BAO BAO、132 5.など、ラインごとの特性、プリーツ技法、素材、シルエット、シーズン背景、現在の需要まで確認し、個々のアイテムにフォーカスして査定します。\nまずはLINEで無料の事前査定。納得いただけた方を、全国対応の宅配買取へご案内します。",
      primaryCtaLabel: "LINEで事前査定する",
      primaryCtaHref: "https://line.me/R/ti/p/@240yzqkh",
      secondaryCtaLabel: "宅配買取を申し込む",
      secondaryCtaHref:
        "https://www.enclopedia-official.com/kaitori/takuhai",
      keywords: [
        "issey miyake buyback",
        "pleats valuation",
        "archive clothing",
        "technical design",
      ],
      visualLabel: "ARCHIVE VALUATION",
      visualTitle: [
        "服の形だけではなく、",
        "技法と思想まで見る。",
      ],
      image: "media/archive_fashion/buyback9.png",
      imageAlt: "ISSEY MIYAKE買取のメイン画像",
    },
    thesis: {
      text:
        "ISSEY MIYAKEの価値は、ブランド名だけでなく、プリーツ技法・素材開発・構造・保存状態・ラインごとの需要まで見て判断する。",
      keywords: ["pleats", "material innovation", "archive rarity"],
    },
    intro: {
      label: "02 / OUR BUYBACK VIEW",
      titleLines: [
        "ISSEY MIYAKEの価値は、",
        "“プリーツの服”だけでは終わらない。",
      ],
      body:
        "ISSEY MIYAKEは、身体と布の関係を技術から変えてきたブランドです。\n一枚の布、プリーツ、折り、伸縮、軽さ、機能性、量産と造形の両立。PLEATS PLEASEやHOMME PLISSÉのような定番ラインがある一方で、ISSEY MIYAKE MEN、A-POC、132 5.、過去シーズンのアーカイブには、それぞれ異なる評価軸があります。\nEnclopediaでは、単に人気ラインかどうかではなく、その一着がどの技法・ライン・時代背景の中にあるかまで確認して査定します。",
    },
    valuation: {
      label: "03 / WHAT WE VALUE",
      titleLines: [
        "Enclopediaが重視する、",
        "3つの査定視点。",
      ],
      items: [
        {
          number: "01",
          title: "技法と素材を見る",
          text:
            "プリーツ、A-POC、折り構造、伸縮性、軽量素材、特殊加工など、ISSEY MIYAKEらしい技術的価値を確認します。",
        },
        {
          number: "02",
          title: "ラインと需要を見る",
          text:
            "PLEATS PLEASE、HOMME PLISSÉ、ISSEY MIYAKE MEN、BAO BAOなど、ラインごとの市場需要と評価軸を分けて判断します。",
        },
        {
          number: "03",
          title: "状態と希少性を見る",
          text:
            "プリーツの伸び、汚れ、引っ掛け、保管状態、サイズ、色柄、流通量、再入手難度を踏まえて個別に査定します。",
        },
      ],
    },
    targetLines: {
      label: "04 / TARGET ITEMS",
      titleLines: [
        "ISSEY MIYAKE全般を、",
        "幅広く査定します。",
      ],
      items: [
        {
          tag: "ITEM 01",
          title: "PLEATS PLEASE ISSEY MIYAKE",
          text:
            "ワンピース、トップス、パンツ、スカート、カーディガン、セットアップなど、需要の高いプリーツプリーズを査定します。",
        },
        {
          tag: "ITEM 02",
          title: "HOMME PLISSÉ ISSEY MIYAKE",
          text:
            "ジャケット、パンツ、トップス、コート、セットアップなど、メンズで人気の高いオムプリッセを確認します。",
        },
        {
          tag: "ITEM 03",
          title: "ISSEY MIYAKE MEN",
          text:
            "ジャケット、コート、パンツ、ニット、シャツなど、廃止ラインを含むメンズアーカイブも丁寧に見ます。",
        },
        {
          tag: "ITEM 04",
          title: "ISSEY MIYAKE / メインライン",
          text:
            "ウィメンズのドレス、コート、トップス、パンツ、造形性の強いコレクションピースを査定します。",
        },
        {
          tag: "ITEM 05",
          title: "A-POC / 132 5. ISSEY MIYAKE",
          text:
            "一枚の布、折り、構造、プロダクト性が強いラインは、技法と希少性を踏まえて個別に確認します。",
        },
        {
          tag: "ITEM 06",
          title: "BAO BAO ISSEY MIYAKE",
          text:
            "トート、ショルダー、クラッチ、限定色、人気モデルなど、状態と需要を見て査定します。",
        },
        {
          tag: "ITEM 07",
          title: "me ISSEY MIYAKE / HaaT",
          text:
            "日常性の高いラインも、柄、素材、状態、現在需要に応じて査定対象として確認します。",
        },
        {
          tag: "ITEM 08",
          title: "過去シーズンのアーカイブ",
          text:
            "古いだけで高くなるわけではありませんが、現在も評価される技法・柄・シルエットを持つ作品はアーカイブ価値まで見ます。",
        },
      ],
    },
    highValueItems: {
      label: "05 / HIGH VALUE ITEMS",
      titleLines: [
        "高価買取につながりやすい、",
        "ISSEY MIYAKEのアイテム。",
      ],
      intro:
        "査定額は状態や市場性で変動しますが、Enclopediaでは特に以下のようなISSEY MIYAKEを丁寧に確認します。",
      items: [
        {
          index: "01",
          title: "PLEATS PLEASEの人気柄・セットアップ・ワンピース",
          text:
            "プリーツプリーズは中古市場でも検索需要が高いラインです。柄、色、サイズ、プリーツ状態、セットアップ可否を確認します。",
        },
        {
          index: "02",
          title: "HOMME PLISSÉのジャケット・パンツ・セットアップ",
          text:
            "オムプリッセは日常で着やすく需要が強いため、定番パンツ、ジャケット、セットアップ、人気色は丁寧に査定します。",
        },
        {
          index: "03",
          title: "ISSEY MIYAKE MENの希少アーカイブ",
          text:
            "廃止ラインであるISSEY MIYAKE MENは、年代・素材・シルエット・保存状態によって価値が変わります。",
        },
        {
          index: "04",
          title: "技法や構造が際立つメインラインの作品",
          text:
            "折り、立体構造、特殊素材、プリーツ以外の技術表現が強いコレクションピースは、単なる古着ではなく作品性を確認します。",
        },
        {
          index: "05",
          title: "BAO BAOの人気モデル・限定色・状態良好品",
          text:
            "BAO BAOは使用感や角擦れ、パーツ状態が査定に影響します。人気モデルや限定カラーは需要を踏まえて確認します。",
        },
      ],
    },
    quote: {
      textLines: [
        "“着やすい服”としてではなく、",
        "布と身体を変える技法として見る。",
      ],
    },
    assessmentDifference: {
      label: "06 / ASSESSMENT DIFFERENCE",
      titleLines: [
        "一般的な査定で、",
        "見落とされやすいISSEY MIYAKEの価値。",
      ],
      intro:
        "ISSEY MIYAKEは、同じブランド名でも、ライン・技法・素材・保存状態によって評価が大きく変わるブランドです。",
      items: [
        {
          index: "01",
          title: "プリーツを一括で見ない",
          text:
            "PLEATS PLEASEとHOMME PLISSÉでは需要層も評価軸も異なります。柄、色、形、サイズ、状態まで分けて確認します。",
        },
        {
          index: "02",
          title: "技法を“デザイン”だけで終わらせない",
          text:
            "A-POCや132 5.のように、作り方そのものが価値になるラインは、プロダクトとしての背景まで見ます。",
        },
        {
          index: "03",
          title: "状態と次の着用価値を重視する",
          text:
            "プリーツの伸び、シミ、引っ掛け、型崩れなどを確認しながら、次の着用者へ渡る価値があるかという視点で査定します。",
        },
      ],
    },
    flow: {
      label: "07 / BUYBACK FLOW",
      titleLines: [
        "LINE事前査定から、",
        "宅配買取へ。",
      ],
      items: [
        {
          step: "STEP 01",
          title: "LINEで事前査定",
          text:
            "写真と簡単な情報をお送りください。全体、ブランドタグ、品番タグ、素材表記、プリーツ状態、汚れや引っ掛け箇所が分かる写真があると確認しやすくなります。",
        },
        {
          step: "STEP 02",
          title: "宅配買取を申込",
          text:
            "本査定をご希望の場合は申込フォームへ。宅配キットの要否もここで選択できます。",
        },
        {
          step: "STEP 03",
          title: "無料で発送",
          text:
            "送料は無料。ご自身の箱または選択制の宅配キットで商品をお送りください。プリーツやバッグはなるべく形を崩さない梱包をおすすめします。",
        },
        {
          step: "STEP 04",
          title: "本査定・ご入金",
          text:
            "到着後に状態・真贋・市場性・アーカイブ価値を確認。金額にご納得いただければご指定口座へ入金します。",
        },
      ],
    },
    assurance: {
      label: "08 / SAFE BUYBACK",
      titleLines: [
        "相談しやすく、",
        "進めやすいISSEY MIYAKE買取。",
      ],
      intro:
        "LINEで相談してから進められるため、プリーツの状態やライン判別に不安があるアイテムも、宅配買取へ進む前に確認できます。",
      items: [
        {
          title: "LINE事前査定あり",
          text:
            "まず相談してから進められるため、状態や市場性に不安がある品も事前に確認できます。",
        },
        {
          title: "送料は無料",
          text:
            "宅配買取の発送費用はEnclopediaが負担します。",
        },
        {
          title: "宅配キットは選択制",
          text:
            "必要な方には宅配キットをご用意。ご自身で梱包できる場合はそのまま発送可能です。",
        },
        {
          title: "キャンセル返送料は基本無料",
          text:
            "査定金額にご納得いただけない場合の返送も基本無料です。",
        },
      ],
      notice:
        "キャンセル返送料は基本無料です。ただし、お送りいただいた品がすべてコピー品、または真贋判定不可品のみだった場合は、返送料をご負担いただく場合があります。",
    },
    faq: {
      label: "09 / FAQ",
      titleLines: [
        "ISSEY MIYAKE買取で、",
        "よくあるご質問。",
      ],
      items: [
        {
          question:
            "どのISSEY MIYAKEアイテムを買取していますか？",
          answer:
            "PLEATS PLEASE、HOMME PLISSÉ、ISSEY MIYAKE MEN、メインライン、A-POC、132 5.、BAO BAO、me ISSEY MIYAKE、HaaTなど幅広くご相談いただけます。",
        },
        {
          question:
            "PLEATS PLEASEは高く売れますか？",
          answer:
            "柄、色、形、サイズ、プリーツ状態、現在需要によって変動します。ワンピース、セットアップ、人気柄、状態の良い品は丁寧に評価します。",
        },
        {
          question:
            "HOMME PLISSÉも査定できますか？",
          answer:
            "はい。HOMME PLISSÉのパンツ、ジャケット、トップス、セットアップ、コートなども査定対象です。定番需要と状態を確認して判断します。",
        },
        {
          question:
            "ISSEY MIYAKE MENの古いアーカイブも買取できますか？",
          answer:
            "はい。ISSEY MIYAKE MENは廃止ラインのため、年代、素材、シルエット、希少性、現在需要を踏まえて個別に査定します。",
        },
        {
          question:
            "BAO BAOのバッグも買取対象ですか？",
          answer:
            "はい。BAO BAOはモデル、色、サイズ、角擦れ、パーツ状態、付属品の有無を確認して査定します。",
        },
        {
          question:
            "ISSEY MIYAKEの買取相場を先に知りたいです。",
          answer:
            "まずはLINEで写真をお送りください。ライン、品番、状態、サイズ、プリーツやバッグの状態、現在需要を確認し、宅配買取へ進む前に大まかな方向性をご案内します。",
        },
      ],
    },
    finalCta: {
      titleLines: [
        "まずはLINEで、",
        "ISSEY MIYAKEの価値をご相談ください。",
      ],
      body:
        "PLEATS PLEASE、HOMME PLISSÉ、ISSEY MIYAKE MEN、A-POC、BAO BAO、アーカイブ作品まで確認。\nEnclopediaが、技法と再流通価値を見て宅配買取へ丁寧につなげます。",
      primaryLabel: "LINEで事前査定する",
      primaryHref: "https://line.me/R/ti/p/@240yzqkh",
      secondaryLabel: "宅配買取を申し込む",
      secondaryHref:
        "https://www.enclopedia-official.com/kaitori/takuhai",
    },
  };

export default article;
